<template>
  <el-dialog title="选择分区"
             custom-class="select-region-dialog"
             width="900px"
             :visible.sync="visibleValue"
             :close-on-press-escape="false"
             :close-on-click-modal="false"
             :modal-append-to-body="true"
             :append-to-body="true"
             @opened="initData"
             @close="resetData"
             @closed="closedCallback">
    <div v-if="repeateData.length" style="color:rgb(199, 56, 56)">
      您所选的分区名称存在重复的邮编号：<span v-for="(item, i) in repeateData" :key="item">{{item}}{{ i+1 === repeateData.length ? '' : ',' }}</span>;
      同一起运地，同一货物类型，同一分区信息内不允许有重复的邮编号，请检查。
    </div>
    <el-divider content-position="left">可选分区({{list.length}})</el-divider>
    <el-form inline size="small"  class="margin-bottom-sm">
      <el-form-item>
        <el-input v-model="searchText" type="textarea" :rows="2" placeholder="温馨提示：用英文逗号隔开可支持批量搜索。"/>
      </el-form-item>
      <el-form-item>
        <el-button type="" @click="searchList">搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" plain @click="cacheSelect">确定选择分区</el-button>
      </el-form-item>
      <br/>
      <el-form-item v-if="list.length">
        <el-button type="primary" @click="toggleSelectAll">全选</el-button>
      </el-form-item>
<!--      <el-form-item>-->
<!--        <el-button type="" plain @click="cacheCurrentPage">缓存当前页</el-button>-->
<!--      </el-form-item>-->
    </el-form>
    <select-region-list ref="canSelect" :list="list" @clickItem="selectItem"/>
    <div v-if="unMatchList.length">
      <el-divider content-position="left">未匹配到分区({{ unMatchList.length }})</el-divider>
      <select-region-list :list="unMatchList"/>
    </div>
    <el-divider content-position="left">已选分区({{selectValue.length}})</el-divider>
    <select-region-list :list="selectValue" @clickItem="unselectItem"/>

    <div class="margin-top" style="text-align: center;">
      <el-button class="footer-btn" type="" @click="closedDialog">取消</el-button>
      <el-button class="footer-btn" type="primary" @click="saveSelect">保存选择</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {mixinsDialog} from "my-element-mixins";
import SelectRegionList
  from "@/components/QuotationManagement/components-productQuotation/selectRegion/selectRegionList";

export default {
  name: "selectRegion",
  components: {SelectRegionList},
  mixins:[mixinsDialog],
  props:{
    regionType: [String, Number],
    defaultList:Array,
    defaultSelect:Array,
    isSegment: Boolean,
    type:{ // 分段类型 1：全包(头程) 2:派送
      type:Number,
      default:1,
    },
    regionList:{//分区列表
      type:Array,
      default:()=>[],
    },
    regionIndex: [Number, String]
  },
  data(){
    return {
      // 可选分区列表
      list:[],
      // 已选择的分区列表
      selectValue:[],
      // 搜索文本
      searchText:"",
      // 搜索文本 记录上一次
      searchTextHistory:"",
      // 记录检查出的重复邮编
      repeateData: [],
      // 是否全选
      selectAll: false,
      unMatchList: [],
    }
  },
  watch:{
    // isShow(val){
    //   if(val) this.initData();
    // }
    regionIndex(val) {
      this.repeateData = []
    }
  },
  methods:{
    /**
     * 重置数据
     */
    resetData(){
      console.log("resetData");
      this.list = [];
      this.selectValue = [];
      this.searchText = "";
      this.searchTextHistory = "";
      this.unMatchList = []
    },
    /**
     * 初始化
     * @param list
     * @param select
     */
    initData(list = this.defaultList,select= this.defaultSelect){
      console.log("initData");
      list = this.processingList(list);
      select =this.processingList(select);
      // this.sortList(list);
      // this.sortList(select);
      this.list = list;
      this.selectValue = select;
      this.searchText = "";
      this.searchTextHistory = "";
    },
    /**
     * 初始化时处理列表
     * @param list
     * @returns {any[]}
     */
    processingList(list = []){
      return list.map(item=>this.processingItem(item));
    },
    processingItem(item){
      return Object.assign({
        isSelect:false,
      },item);
    },
    /**
     * 排序
     * @param list
     */
    sortList(list = []){
      list.sort((r1,r2)=>{
        if(r2.namec > r1.namec) return 1
        if(r2.namec < r1.namec) return -1
        return 0
      })
    },
    /**
     * 点击选择 可选分区（仅标记）
     * @param item
     * @param index
     */
    selectItem(item,index){
      console.log("selectItem",item,index);
      // let i = this.list.findIndex(v => v.warehouseId === item.warehouseId);
      // if(i>=0){}
      item.isSelect = !item.isSelect;
    },
    /**
     * 点击取消 已选分区
     * @param item
     * @param index
     */
    unselectItem(item,index){
      console.log("unselectItem",item,index);
      let i = this.selectValue.findIndex(v => v.warehouseId === item.warehouseId);
      console.log(i);
      if(i>=0){
        this.selectValue.splice(i,1);
      }
      this.list.push(item);
    },
    async checkRepeateZipCode(cacheList) {
      let list = JSON.parse(JSON.stringify(this.regionList))
      // // 已选的分区
      // this.selectValue.forEach((item, index) => {
      //   if (list[this.regionIndex].regionDetailList.findIndex(e => e.warehouseId === item.warehouseId) === -1) {
      //     list[this.regionIndex].regionDetailList.push(item)
      //   }
      // })
      // // 将要缓存的分区
      // cacheList.forEach(item => {
      //   if (list[this.regionIndex].regionDetailList.findIndex(element => element.warehouseId === item.warehouseId) === -1) {
      //     list[this.regionIndex].regionDetailList.push(item)
      //   }
      // })
      let regionList = cacheList.concat(this.selectValue)
      const uniqList = regionList.filter((item, index, self) => {
        return self.findIndex(e => e.warehouseId === item.warehouseId) === index
      })
      list[this.regionIndex].regionDetailList = uniqList
      const data = {
        isSegment: this.isSegment,
        regionHeaderList: this.type === 1 ? list : [],
        deliveryRegionHeaderList: this.type === 2 ? list : []
      }
      const response = await this.axios.post('/api/carrier/productPriceNew/verifyZipCodeByZone', data).catch(() => {
        this.$message.error('检查分区内邮编时异常，请稍候重试')
      })
      console.log(response)
      if (response) {
        if (response.data.code != 200) {
          this.$message.error(response.data.message)
          return false
        }else if(response.data.datas && response.data.datas.length) {
          this.repeateData = response.data.datas
          return false
        } else {
          this.repeateData = []
          return true
        }
      } else {
        this.repeateData = []
        return false
      }
    },
    /**
     * 缓存 被标记的可选分区 为已选
     */
    async cacheSelect(){
      let cacheList = [];
      let list = this.list.filter(item=>{
        if(item.isSelect){
          item.isSelect = false;
          cacheList.push(item)
          return false
        }
        return true
      });
      if(cacheList.length){
        // this.sortList(list);
        if (this.regionType === 5) {
          const flag = await this.checkRepeateZipCode(cacheList)
          if (!flag) return
        }
        if (this.regionType === 6) {
          const cacheLength = cacheList.length
          const selectLength = this.selectValue.length || 0
          if (cacheLength + selectLength > 1) return this.$message.warning('多国家分区每个分区只能选择一个国家')
        }
        this.list = list;
        this.selectValue.push(...cacheList);
      }else {
        this.$message.warning("先至少选中一个可选分区")
      }
    },
    /**
     * 缓存当前页
     */
    cacheCurrentPage(){
      let $canSelect = this.$refs.canSelect;
      if($canSelect && $canSelect.pagingList){
        let cacheList = $canSelect.pagingList.slice();
        let ids = cacheList.map(item=>item.warehouseId);
        let list = this.list.filter(item=> !ids.includes(item.warehouseId) );
        this.list = list;
        this.selectValue.push(...cacheList);
      }
    },
    /**
     * 保存操作
     */
    saveSelect(){
      // if(this.selectValue.length ===0 && (!this.defaultSelect || this.defaultSelect.length ===0)){
      if(this.selectValue.length ===0){
        return this.$message.error("请至少选择一条分区（选中可选分区后请点击\"确定选择分区\"）")
      }
      let selectList = this.selectValue.map(item=>{
        item = Object.assign({},item,{isSelect:undefined});
        return item
      });
      this.$emit("select",selectList);
      this.closedDialog();
    },
    searchList(){
      let searchText = this.searchText || "";
      console.log("searchList",searchText,this.searchTextHistory === searchText);
      if(this.searchTextHistory === searchText) return false;
      this.searchTextHistory = searchText;
      let batchTextArr = searchText.replace(/，/g,",").split(",");
      let alreadySelectIds = this.selectValue.map(item=>item.warehouseId);
      let list =[];
      let unMatchList = []
      let matchTextList = []
      this.defaultList.forEach(item=>{
        if(alreadySelectIds.includes(item.warehouseId)) return false;
        if(searchText){
          // let check =`${item.namec}`.match(searchText);
          let check = batchTextArr.some(text => {
            let flag = `${item.namec}`.match(text)
            if (flag) matchTextList.push(text)
            return flag
          })
          if(!check) return false;
        }
        let target = this.processingItem(item);
        list.push(target);
      });
      // 添加未匹配到的搜索字段
      if (searchText) {
        batchTextArr.forEach((text, i) => {
          if (!matchTextList.includes(text)) {
            const unMatch = {
              namec: text,
              warehouseId: i,
            }
            unMatchList.push(unMatch)
          }
        })
      }
      this.list = list;
      this.unMatchList = unMatchList;
    },
    toggleSelectAll() {
      let list = this.list;
      let selectAll = !this.selectAll;
      if (selectAll) {
        this.selectAll = selectAll;
        list.forEach(item=>{
          item.isSelect = true;
        })
      } else {
        this.selectAll = selectAll;
        list.forEach(item=>{
          item.isSelect = false;
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
/deep/ .select-region-dialog{
  .el-dialog__body{
    padding-top: 0;
  }
}

.footer-btn{
  width: 140px;
}
</style>



// WEBPACK FOOTER //
// src/components/QuotationManagement/components-productQuotation/selectRegion/index.vue